import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ApiStatusWrapper, AppContainer, UserForm } from "../components";
import { ApiMethodTypes, useApi } from "../hooks";
import { AuthApi } from "../utils/api";
import { Row, Col } from "antd";

export const User = () => {
  const { userId } = useParams();

  const {
    sendRequest: userInfoSendRequest,
    data: userInfoData,
    apiStatus: userInfoApiStatus
  } = useApi({ method: ApiMethodTypes.Get });

  //fetch user info data
  useEffect(
    () => {
      userInfoSendRequest({ url: AuthApi.GetUserByIdUrl({ userId: userId }) });
    },
    [userId, userInfoSendRequest]
  );
  const submitUrl = AuthApi.PutUserByIdUrl({ userId });

  return (
    <AppContainer>
      <Row gutter={16}>
        <Col xl={12} sm={24}>
          <ApiStatusWrapper statuses={[userInfoApiStatus]}>
            <UserForm
              data={userInfoData}
              submitUrl={submitUrl}
              submitUrlMethodType={ApiMethodTypes.Put}
            />
          </ApiStatusWrapper>
        </Col>
      </Row>
    </AppContainer>
  );
};
